export default __webpack_public_path__ + "static/media/home_5.ba32b16a.svg";